/**
 * Barre de maintien
 */
import CustomObject from '../CustomObject.js'

export default class ShowerGrabBar extends CustomObject
{
    constructor(modelPath, position, id, rotation) {
        super(modelPath, position, id, rotation);
        this.type = "showerGrabBar";
        if(this.position.y == 0) {
            this.position.y = 0.7;
        }
        this.collisionAllowed = true;
        this.snappingAllowed = true;
        this.axesMove = [true, true, true]; // x, y
    }
}